import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiTeamSectionDTO extends StrapiDynamicZoneComponentDTO {
  heading: string;
  intro: string;
  layout: "Cards" | "Compact";
  showBio: boolean;
}

export class TeamSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  intro: MDXRemoteSerializeResult;
  layout: "Cards" | "Compact";
  showBio: boolean;
}
